module.exports = __webpack_public_path__ + "static/media/polylogo.4b8412cc.png";